import { styled } from '../../../../styled'

export const DocType = styled.div`
  padding: 20px 16px 0 16px;
  overflow: auto;
  font-size: 14px;
`



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Playground/DocExplorer/DocsTypes/DocType.tsx